export function invoiceTotalValueGetter(_value, row) {
    try {
        const data = JSON.parse(row?.invoiceValues || 'null');
        return data?.finalTotal ?? null;
    } catch {
        return null;
    }
}

export function surveyUploaderValueGetter(_value, row) {
    const firstName = row.customerFirstName ?? '';
    const lastName = row.customerLastName ?? '';
    return `${firstName} ${lastName}`.trim();
}

export function estimateStatusValueGetter(_value, row) {
    const { isProcessed } = row;
    if (isProcessed === 1 || isProcessed === 4) {
        return 'Complete';
    }
    if (isProcessed === 2) {
        return 'Complete N/P';
    }
    return '';
}

export function employeeStatusValueGetter(_value, row) {
    return row?.deleted === null ? 'Active' : 'Deactivated';
}
